import React, { useEffect, useState, useContext } from "react";
import { userService } from "../../services/api"; // Adjust path as needed
import { AuthContext } from "../../context/AuthContext";

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1); // New state for page
  const [hasMore, setHasMore] = useState(true); // Optional: to disable next when no more pages

  const { currentUser } = useContext(AuthContext);

  const fetchUsers = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await userService.getUsers({ page: pageNumber });
      const usersData = response.data || {};
      setUsers(usersData.results || usersData);
      setHasMore(usersData.next !== null); // Optional: if API provides a `next` field
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (currentUser) {
      setIsAdmin(currentUser.profile.role === "admin");
    }
  }, [currentUser]);

  useEffect(() => {
    if (isAdmin) {
      fetchUsers(page);
    }
  }, [isAdmin, page]);

  if (loading) return <div>Loading...</div>;

  if (!isAdmin) return <div>Access denied. Admins only.</div>;

  return (
    <div>
      <h2>Users List</h2>
      <table border="1" cellPadding="8" cellSpacing="0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          {users && users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id || user._id}>
                <td>{user.id || user._id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.profile?.role}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No users found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div style={{ marginTop: "16px" }}>
        <button 
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))} 
          disabled={page === 1}
        >
          Previous
        </button>
        <span style={{ margin: "0 10px" }}>Page {page}</span>
        <button 
          onClick={() => setPage((prev) => prev + 1)} 
          disabled={!hasMore}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default UsersList;
